import { toast } from 'react-toastify';
import { setPolylineDistanceTooltipCoords } from '../../../../../../app/redux/slices/PolylineDistanceTooltipCoordsSlice';
import { setIsUsingMeasuringTool } from '../../../../../../app/redux/slices/isUsingMeasuringToolSlice';
import { GetElevationDataApi } from '../../../../../../core/data/api/elevation-data/get/GetElevationDataApi';
import { convertElevationPointsToLatLngObject } from '../../../../../../core/utils/map.utils';
import { sendDataToParent } from '../../../../base/functions/sendDataToParent';

export const measureToolOnCreated = (e, dispatch, setMeasuringToolLines, setMeasuringToolIds, isSlopeServiceActive) => {
    setMeasuringToolIds((prevIds) => [...prevIds, e.layer._leaflet_id]);

    if (isSlopeServiceActive && e.layer._latlngs.length === 2) {
        async function callElevationApi() {
            const result = await GetElevationDataApi(e.layer._latlngs);
            const convertedPoints = result && convertElevationPointsToLatLngObject(result);
            dispatch(
                setPolylineDistanceTooltipCoords({
                    id: e.layer._leaflet_id,
                    coords: result ? convertedPoints : e.layer._latlngs,
                }),
            );
            setMeasuringToolLines((prevMeasureLines) => [...prevMeasureLines, e.layer]);
            e.layer.remove();
        }

        toast.promise(callElevationApi(), {
            pending: 'اطلاعات مختصات در حال محاسبه است...',
            // success: 'Promise  Loaded',
            // error: 'error',
        });
    } else if (e.layer._latlngs.length === 2) {
        dispatch(
            setPolylineDistanceTooltipCoords({
                id: e.layer._leaflet_id,
                coords: e.layer._latlngs,
            }),
        );
        setMeasuringToolLines((prevMeasureLines) => [...prevMeasureLines, e.layer]);
        e.layer.remove();
    } else e.layer.remove();
};
